/** Class used to communicate the service with the component for display and data exchange.*/
export class MessageRibbon {
  messageType: string;
  messageContent: string;
  messageAutoClose: string;
  messageHeader: string;
  messageName: string;
}
